import { a as __rest, _ as __assign } from './_tslib-ff3a08af.js';
import { jsx } from 'react/jsx-runtime';
import { makeStyles } from '@material-ui/core';
import { s as styleConstants } from './constants-3b80be2a.js';

var useStyles = makeStyles({
    wrapper: {
        cursor: 'pointer',
        color: styleConstants.colors.grey,
        transition: 'color 0.2s ease-in-out',
        '&:hover': {
            color: 'black'
        }
    }
});
var ClearIndicator = function (_a) {
    var innerProps = _a.innerProps;
    var classes = useStyles();
    var ref = innerProps.ref,
        restInnerProps = __rest(innerProps, ["ref"]);
    return jsx("div", __assign({ className: classes.wrapper }, restInnerProps, { ref: ref, children: "Clear" }));
};

export { ClearIndicator as C };
